import * as React from 'react';
import { css, cx } from '@emotion/css';
import { rem } from 'polished';

import type { LinkType } from '../link';

import { styled } from './themeContext';
import Link from './Link';
import backgroundImageUrl from './facebookButton/background.png';
import { ReactComponent as FacebookLogoSvg } from './facebookButton/facebookLogo.svg';

type FacebookButtonProps = {
  facebookLink?: LinkType,
  facebookButtonText: string,
};

const Container = styled.div((props) => ({
  pointerEvents: 'all',
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  textAlign: 'center',
  width: rem(43),
  height: rem(60),
  [props.theme.media['md']]: {
    width: rem(83),
    height: rem(114),
  },
}));

const BackgroundImg = styled.img({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  width: '100%',
  height: '100%',
});

const ButtonText = styled.p(props => ({
  position: 'relative',
  color: '#FAF5D1',
  fontSize: rem(8),
  lineHeight: rem(9),
  whiteSpace: 'pre',
  margin: `${rem(-3)} 0 0 0`,
  [props.theme.media['md']]: {
    fontSize: rem(16),
    lineHeight: rem(18),
    margin: `${rem(-6)} 0 0 0`,
  },
}));

const FacebookLogoIcon = styled(FacebookLogoSvg)(props => ({
  position: 'relative',
  marginTop: rem(4),
  width: rem(10),
  height: rem(19),
  [props.theme.media['md']]: {
    marginTop: rem(8),
    width: rem(20),
    height: rem(38),
  },
}));

const FacebookButton: React.FC<FacebookButtonProps> = ({
  facebookLink,
  facebookButtonText,
}) => {
  return (
    <Link
      link={facebookLink}
      className={cx(
        css({ textDecoration: 'none' }),
      )}
    >
      <Container>
        <BackgroundImg src={backgroundImageUrl} />
        <ButtonText>{facebookButtonText}</ButtonText>
        <FacebookLogoIcon />
      </Container>
    </Link>
  );
};

export default FacebookButton;
